import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource, invalidateResource } from "kea-resource";
import * as rx from "rxjs";
import { EntregaZERealizadaForm } from "../../viajeappZE/entrega/formn";

type Entity = models.EntregaZERealizadaDTO;

interface Props {
    match: match<{ id: string }>
}

interface State {
    value?: Entity;
}

class EntregaZERealizadaEditNoRX extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    idStr = (props: Props, state: State) => this.props.match.params.id;
    idEntrega = createSelectorRx(this.idStr, id => Number.parseInt(id));
    value = createSelectorRx(this.idEntrega, (id) => observeResource(resources.ViajeZEApp.ObtenerEntrega, id));
    informacionEntrega = createSelectorRx(this.value, (value) => observeResource(resources.ViajeZEApp.ObtenerInformacionEntrega, value.IdViajeZE, value.IdDireccionDestino, value.IdRegistro));

    onGuardar = async () => {

    }

    render() {
        const informacionEntrega = this.informacionEntrega(this.props, this.state);
        const value = this.value(this.props, this.state);

        return <EntregaZERealizadaForm
            value={value}
            nuevo={false}
            informacion={informacionEntrega}
            onChange={x => { }}
            onGuardar={this.onGuardar} />;
    }

}

export const EntregaZERealizadaEdit = withRouter(EntregaZERealizadaEditNoRX);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/entregasZERealizadas/edit/edit.tsx